document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth < 990) return;

  var body = document.body;

  var header =
    document.querySelector('.shopify-section-header') ||
    document.querySelector('.header-wrapper') ||
    document.querySelector('.site-header') ||
    document.querySelector('.header') ||
    document.querySelector('header');

  if (!header) return;

  function setOverlayTop() {
    var rect = header.getBoundingClientRect();
    var top = rect.bottom > 0 ? rect.bottom : 100;
    document.documentElement.style.setProperty('--mega-overlay-top', top + 'px');
  }

  function openOverlay() {
    if (window.innerWidth < 990) return;
    setOverlayTop();
    body.classList.add('mega-menu-overlay-active');
  }

  function closeOverlay() {
    body.classList.remove('mega-menu-overlay-active');
  }

  /* Most common parent menu item selectors in Shopify themes */
  var menuItems = header.querySelectorAll(
    'li, .site-nav__item, .header__menu-item, .menu-item, .navigation__item'
  );

  menuItems.forEach(function (item) {
    var hasDropdown =
      item.querySelector('.megamenu, .mega-menu, .mega-menu__content, .site-nav__dropdown, .submenu, .sub-menu, .dropdown-menu, .header__submenu, .navigation-dropdown');

    if (!hasDropdown) return;

    item.addEventListener('mouseenter', function () {
      openOverlay();
    });

    item.addEventListener('mouseleave', function () {
      closeOverlay();
    });
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth < 990) {
      closeOverlay();
    } else if (body.classList.contains('mega-menu-overlay-active')) {
      setOverlayTop();
    }
  });

  window.addEventListener('scroll', function () {
    if (body.classList.contains('mega-menu-overlay-active')) {
      setOverlayTop();
    }
  }, { passive: true });
});